<template lang="pug">
  .site-container
    .b-login-page.empty-page
      ._container.empty-page-container
        ._content.empty-page-content
          AuthLogo(page="login")._left
          AuthLoginForm._right
        AuthFooter
</template>

<script>
import AuthLogo from '@/components/AuthLogo.vue';
import AuthLoginForm from '@/components/AuthLoginForm.vue';
import AuthFooter from '@/components/AuthFooter.vue';

export default {
  components: { AuthLogo, AuthLoginForm, AuthFooter },
};
</script>

<style lang="scss" scoped>
.login-page {
  &__left {
    padding-right: 50px;
  }

  &__right {
    text-align: center;
    padding: 0 106px 0 158px;
    border-left: 1px solid var(--color-purple);
  }

  @media (max-width: 1024px) {
    &__container {
      width: calc(100% - 40px);
      padding: 0 20px;
    }

    &__content {
      padding: 50px 20px;
      justify-content: center;
    }

    &__left {
      padding-right: 30px;
    }

    &__right {
      padding: 0 30px;
    }
  }

  @media (max-width: 768px) {
      &__container {
        width: calc(100% - 150px);
        padding: 25px 15px;
      }

    &__content {
      flex-direction: column-reverse;
    }

    &__left {
      padding-right: 0;
    }

    &__right {
      padding: 0;
      margin-bottom: 24px;
      padding-bottom: 28px;
      border-bottom: 1px solid var(--color-purple);
      border-left: none;
    }
  }

  @media (max-width: 576px) {
    &__container {
      width: 100%;
    }
  }

  @media (max-width: 500px) {
    &__content {
      padding: 45px 20px 38px 20px;
    }

    &__left {
      width: 100%;
    }

    &__right {
      padding-bottom: 28px;
      width: 100%;
    }
  }
}
</style>
